var _path, _path2, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockSmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4668 66.0471H104.533C111.327 66.0471 116.834 71.5463 116.834 78.3284V118.804C116.834 125.586 111.327 131.085 104.533 131.085H55.4668C48.6732 131.085 43.1671 125.586 43.167 118.804V78.3284C43.1672 71.5463 48.6732 66.0472 55.4668 66.0471Z",
    stroke: "url(#paint0_linear_278_24109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 65.5472V51.767C104 39.0827 93.2548 28.8 80 28.8C66.7452 28.8 56 39.0827 56 51.767V65.5472",
    stroke: "url(#paint1_linear_278_24109)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0004,
    cy: 98.5663,
    rx: 7.46666,
    ry: 7.45594,
    fill: "#7DDFBB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_278_24109",
    x1: 80.0003,
    y1: 65.5471,
    x2: 80.0003,
    y2: 131.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B59AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_278_24109",
    x1: 80,
    y1: 28.8,
    x2: 80,
    y2: 65.5472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B59AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSmIcon);
export default __webpack_public_path__ + "static/media/lock-sm-icon.1db15401c140e39a66ff378b3080ea05.svg";
export { ForwardRef as ReactComponent };